<template>
  <div v-bind:style="{ height: height + 'px' }">
    <ag-grid-vue
      style="width: 100%; height: 100%;"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :paginationAutoPageSize="false"
      :paginationPageSize="paginationPageSize"
      :pagination="true"
      id="CustomersGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :context="context"
      :frameworkComponents="frameworkComponents"
      :defaultColDef="defaultColDef"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import agGrid from "@/mixins/agGrid.js";
import { link } from "@/components/agGrid/cellRenderers";
import SourceOrderNumberLink from "./cellRenderers/SourceOrderNumberLink";

export default {
  name: "CustomersGrid",
  data() {
    return {
      columnDefs: null,
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true
    };
  },
  props: {
    height: {
      type: String,
      default: "600"
    }
  },
  components: {
    AgGridVue,
    SourceOrderNumberLink, // eslint-disable-line
  },
  mixins: [agGrid],
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {},
    orderLink(params) {
      return `<a href="orders/${params.value}" class="text-blue-500 hover:text-blue-800" >${params.value}</a>`;
    }
  },
  beforeMount() {
    this.gridOptions = {
      localeText: { noRowsToShow: "No Records Found" }
    };
    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex: 1,
      suppressMovable: true
    };

    this.columnDefs = [
      {
        headerName: "Customer ID",
        field: "CustomerID",
        cellRenderer: "linkCell",
        cellRendererParams: {
          clicked: field => {
            this.$store.dispatch("customers/fetchCustomer", field).then(() => {
              // avoid redundant router push if already on the customers/details view
              if (this.$route.path !== "/customers/details")
                this.$router.push({ name: "Details" });
            });
          }
        }
      },
      {
        headerName: "Name",
        field: "FullName"
      },
      {
        headerName: "Email",
        field: "Email"
      },
      {
        headerName: "Phone Index",
        field: "PhoneIndex"
      },
      {
        headerName: "Phone",
        field: "Phone"
      },
      {
        headerName: "City",
        field: "City"
      },
      {
        headerName: "State",
        field: "State"
      },
      {
        headerName: "Last Order",
        field: "last_order",
        cellRendererFramework: "SourceOrderNumberLink",
      }
    ];

    this.frameworkComponents = {
      linkCell: link
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
    rowData: {
      get() {
        let customers = this.$store.getters["customers/getCustomers"];
        return customers.data;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

.ag-row-hover {
  background-color: #f3faf7 !important;
}
.ag-header-cell-label .ag-header-cell-text {
  white-space: normal !important;
  text-align: center;
}
</style>
